import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-800 text-white rounded-lg shadow-xl border border-gray-700 p-5 max-w-md z-10 w-full mx-4 md:w-auto" }
const _hoisted_2 = { class: "flex items-start mb-4" }
const _hoisted_3 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_5 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = { class: "mt-2 text-gray-300" }
const _hoisted_8 = { class: "flex justify-end space-x-3 mt-6" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "animate-spin h-4 w-4 mr-2 inline-block",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal-fade" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 flex items-center justify-center z-50",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm" }, null, -1)),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex-shrink-0 mr-4 p-2 rounded-full", [
              _ctx.type === 'danger'
                ? 'bg-red-900 text-red-400'
                : _ctx.type === 'warning'
                ? 'bg-yellow-900 text-yellow-400'
                : 'bg-blue-900 text-blue-400',
            ]])
                }, [
                  (_ctx.type === 'danger')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[3] || (_cache[3] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        }, null, -1)
                      ])))
                    : (_ctx.type === 'warning')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[4] || (_cache[4] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[5] || (_cache[5] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          }, null, -1)
                        ])))
                ], 2),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h3", {
                    class: _normalizeClass(["text-lg font-medium", _ctx.titleClass])
                  }, _toDisplayString(_ctx.title), 3),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.message), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                  class: "px-4 py-2 bg-gray-700 text-gray-300 rounded-md hover:bg-gray-600 transition-colors font-medium"
                }, _toDisplayString(_ctx.cancelText), 1),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm'))),
                  class: _normalizeClass(["px-4 py-2 rounded-md font-medium transition-colors", _ctx.confirmButtonClass]),
                  disabled: _ctx.isLoading
                }, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[6] || (_cache[6] = [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }, null, -1),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.confirmText), 1)
                ], 10, _hoisted_9)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}